import { Component, ElementRef, EventEmitter, HostListener, OnInit, Output, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import * as Chart from 'chart.js';
import { AgentService } from 'src/app/agent/services/agent.service';
import { BaseComponent } from 'src/app/system-common/base/base.component';
import { SettingService } from 'src/app/system-common/services/setting.service';

@Component({
  selector: '',
  template: '',
})
export class EarningHandlerComponent extends BaseComponent<AgentService> implements OnInit {
  chart: Chart;
  barGraph: boolean;
  public searchName;
  public currentSelectedTheme;
  @Output() closeChart = new EventEmitter<any>();

  constructor(agentService: AgentService, public settingService: SettingService, public router: Router) {
    super(agentService);
    this.barGraph = true;
    this.searchName = 'SearchEarnings';
  }

  ngOnInit() {
    this.currentSelectedTheme = this.settingService.getSessionStorageValue('currentSelectedTheme');
    if (
      (this.currentSelectedTheme != undefined || this.currentSelectedTheme != null) &&
      this.currentSelectedTheme.endsWith('.css')
    ) {
      this.currentSelectedTheme = this.currentSelectedTheme.replace('.css', '');
    }
    this.getSearchList();
  }

  getSearchList() {
    this.service.getSearchList('SearchEarnings').subscribe((response: any) => {
      this.renderChartFromResponse(response);
    });
  }

  renderChartFromResponse(response: any) {
    const isMobile = this.settingService.isMobileViewRendered();
    const labels = response.data.searchResultData.map((item) => item[0].trim());
    const values = response.data.searchResultData.map((item) => item[1]);
    const ctx = document.getElementById('earningsChart') as HTMLCanvasElement;
    if (this.chart) {
      this.chart.destroy();
      this.chart = null;
    }
    this.chart = new Chart(ctx, {
      type: 'bar',
      data: {
        labels: labels,
        datasets: [
          {
            label: '2025',
            data: values,
            backgroundColor: '#1F78B4',
            borderRadius: 4,
            categoryPercentage: 0.5,
            barPercentage: 0.9,
          },
        ],
      },
      options: {
        responsive: true,
        maintainAspectRatio: true,
        layout: { padding: { left: 30, right: 30 } },
        hover: { mode: 'nearest', intersect: true },
        tooltips: {
          callbacks: {
            label: function (tooltipItem, data) {
              let label = data.datasets[tooltipItem.datasetIndex].label || '';
              let value = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
              return `${label}: ${value.toLocaleString()}`;
            },
          },
          bodyFontFamily: 'montserratregular, Arial, Helvetica, sans-serif',
        },
        scales: {
          xAxes: [
            {
              stacked: false,
              scaleLabel: {
                display: true,
                // labelString: '2025',
                fontColor: this.currentSelectedTheme == 'dark' ? '#fff' : '#000',
                fontFamily: 'montserratregular',
                fontSize: isMobile ? 10 : 14,
              },
              gridLines: {
                color: this.currentSelectedTheme === 'dark' ? 'rgba(255,255,255,0.2)' : 'rgba(0,0,0,0.1)',
                zeroLineColor: this.currentSelectedTheme === 'dark' ? '#fff' : 'rgba(10, 10, 10, 0.2)',
                drawBorder: true,
                lineWidth: 1,
              },
              ticks: {
                fontSize: isMobile ? 8 : 12,
                fontColor: this.currentSelectedTheme == 'dark' ? '#fff' : '#000',
                fontFamily: 'montserratregular',
              },
            },
          ],
          yAxes: [
            {
              stacked: false,
              scaleLabel: {
                display: true,
                fontColor: this.currentSelectedTheme == 'dark' ? '#fff' : '#000',
                fontFamily: 'montserratregular',
                fontSize: isMobile ? 10 : 14,
              },
              gridLines: {
                color: this.currentSelectedTheme === 'dark' ? 'rgba(255,255,255,0.2)' : 'rgba(0,0,0,0.1)',
                zeroLineColor: this.currentSelectedTheme === 'dark' ? '#fff' : 'rgba(10, 10, 10, 0.2)',
                drawBorder: true,
                lineWidth: 1,
              },
              ticks: {
                beginAtZero: true,
                fontSize: isMobile ? 8 : 12,
                fontColor: this.currentSelectedTheme == 'dark' ? '#fff' : '#000',
                fontFamily: 'montserratregular',
                callback: function (value) {
                  return value.toLocaleString();
                },
              },
            },
          ],
        },
        legend: {
          display: false,
          position: 'bottom',
          labels: {
            fontSize: isMobile ? 8 : 12,
            padding: isMobile ? 5 : 10,
            boxWidth: isMobile ? 20 : 40,
            fontColor: this.currentSelectedTheme == 'dark' ? '#fff' : '#000',
            fontFamily: 'montserratregular',
          },
        },
        plugins: {
          datalabels: false,
        },
      },
    });
  }

  onGraphPointClick(e) {
    let link = '/search-payment-statement';
    this.router.navigate([link]);
  } // Close the Chart on click of the close button
  onCloseClick() {
    this.closeChart.emit(this.chart);
  }
}
